<template>
  <span>
    <v-tooltip bottom>
    <template v-slot:activator="{ on }">
            <span v-on="on">
              <arb-btn-menu
                v-model="basic.actionList"
                btnType="widthIconBtn"
                icon="videogame_asset"
                @click="clickActionEventHandler"
              >
              </arb-btn-menu>
            </span>
    </template>
    <span>Payment Plan Emulator</span>
  </v-tooltip>
  <v-dialog v-model="multiDialog.display" persistent :max-width="'950px'">
    <payment-schedule-action-card
      v-if="multiDialog.display"
      v-model="multiDialog.data"
      :loan="loan"
      :slaveLoanId="slaveLoanId"
      :setting="multiDialog.setting"
      :hideAction="hideDialog"
      :disableSaveBtn=true
      :hasSaveBtn=false
      :operateFunction="multiDialog.operateFunction"
      returnDataType="multiData"
      showTable="true"
    >
        </payment-schedule-action-card>
  </v-dialog>
  </span>
</template>

<script>
import { DataType, Tool, Popup } from '@/util/index'
import { ProcessingApi } from '@/api/pandaria'
import { LOS_DIALOG_LAYOUT_SETTING } from '@/setting/layout/pre-origination/dialog'
import PaymentScheduleActionCard from '@/components/panda/post-origination/dialog/PaymentScheduleActionCard'

const tool = new Tool()
const popup = new Popup()
export default {
  name: 'payment-plan-emulator-dialog',
  components: {
    PaymentScheduleActionCard
  },
  props: {
    loan: Object,
    slaveLoanId: Number
  },
  data () {
    return {
      basic: {
        actionList: [
          {
            text: DataType.ChangeTypeEnum.PAY_OFF.text,
            value: DataType.ChangeTypeEnum.PAY_OFF.value
          },
          {
            text: DataType.ChangeTypeEnum.PAY_OFF_IN_N.text,
            value: DataType.ChangeTypeEnum.PAY_OFF_IN_N.value
          },
          {
            text: DataType.ChangeTypeEnum.PAY_DOWN.text,
            value: DataType.ChangeTypeEnum.PAY_DOWN.value
          }
        ]
      },
      multiDialog: {
        action: 'EDIT',
        display: false,
        setting: {},
        data: {}
      },
      dataType: DataType,
      multiActionSetting: LOS_DIALOG_LAYOUT_SETTING.MULTI_PAYMENT_SCHEDULE_ACTION,
      effectiveDate: ''
    }
  },
  computed: {
    loanId () {
      return this.loan.id
    }
  },
  methods: {
    hideDialog () {
      this.multiDialog.display = false
    },
    getEffectiveDate () {
      let effectiveDate = ''
      try {
        const nextBusinessDay = this.store.getters.getNextBusinessDay
        const firstCreditDate = this.store.getters.getFirstCreditDate
        if (new Date(nextBusinessDay.toString()).getTime() >= new Date(firstCreditDate.toString()).getTime()) {
          effectiveDate = nextBusinessDay
        } else {
          effectiveDate = firstCreditDate
        }
      } catch (err) {}
      this.effectiveDate = effectiveDate
    },
    clickActionEventHandler (changeType) {
      if (tool.isEmpty(this.store.getters.getPaymentSchedule)) {
        popup.popupForWarning('Has no payment installment')
      } else {
        this.getEffectiveDate()
        if (tool.isNotEmpty(this.loanId) && tool.isNotEmpty(this.effectiveDate)) {
          let loanId = this.loanId
          if (this.loan.loanType === DataType.LoanTypeEnum.MULTIPLE_ADVANCE_LOAN.value) {
            loanId = this.slaveLoanId
          }
          for (const key of Object.keys(this.multiActionSetting)) {
            if (changeType === this.multiActionSetting[key].value) {
              this.multiDialog.setting = this.multiActionSetting[key]
              this.loadMultiActionData(this.multiActionSetting[key].value, loanId)
            }
          }
          this.multiDialog.display = true
        } else {
          this.$popWarningAlert({ text: 'wait a minute' })
        }
      }
    },
    async loadMultiActionData (changeType, loanId) {
      const input = {
        effectiveDate: this.effectiveDate,
        loanId: loanId,
        changeType: changeType,
        action: DataType.MultiActionRequestEnum.PREVIEW.value
      }
      this.multiDialog.operateFunction = (input) => { this.multiOperation(input, changeType) }
      switch (changeType) {
        case DataType.PaymentScheduleAction.PAY_OFF.value:
          input.transactionMode = this.dataType.TransactionModeEnum.ACH.value
          break
        case DataType.PaymentScheduleAction.PAY_OFF_IN_N.value: {
          input.debitCount = 2
          const loanInStore = this.store.getters.getLoan
          const payrollFrequency = {
            payrollFrequency: loanInStore.payrollFrequency,
            firstDayOfMonth: loanInStore.firstDayOfMonth,
            secondDayOfMonth: loanInStore.secondDayOfMonth,
            firstDayOfWeek: loanInStore.firstDayOfWeek
          }
          Object.assign(input, payrollFrequency)
          break
        }
        case DataType.PaymentScheduleAction.PAY_DOWN.value:
          input.transactionMode = this.dataType.TransactionModeEnum.ACH.value
          input.extraPrincipal = 20
          break
        default:
          break
      }
      await this.multiOperation(input, changeType)
    },
    async multiOperation (input, changeType) {
      const $this = this
      input.multiplePreview = true
      await ProcessingApi.multiOperation(
        input,
        function (data) {
          $this.multiOperationCallback(data, input, changeType)
          $this.multiDialog.display = true
        },
        function (err) {
          $this.multiOperationFailureCallBack(err, input, changeType)
          $this.multiDialog.display = true
        }
      )
    },
    multiOperationCallback (data, input, changeType) {
      this.multiDialog.data = data
      this.multiDialog.disableSaveBtn = false
      this.multiDialog.data.effectiveDate = input.effectiveDate
      const inputPayrollFrequency = {
        payrollFrequency: input.payrollFrequency,
        firstDayOfMonth: input.firstDayOfMonth,
        secondDayOfMonth: input.secondDayOfMonth,
        firstDayOfWeek: input.firstDayOfWeek
      }
      switch (changeType) {
        case DataType.PaymentScheduleAction.PAY_OFF.value:
          this.store.commit('setMultiPayOffUnpaidFee', data.unpaidFee)
          this.multiDialog.data.transactionMode = input.transactionMode
          break
        case DataType.PaymentScheduleAction.PAY_OFF_IN_N.value:
          this.store.commit('setMultiPayOffUnpaidFee', data.unpaidFee)
          this.store.commit('setMultiPayOffInNDebitCount', data.maxDebit)
          this.multiDialog.data.debitCount = input.debitCount
          Object.assign(this.multiDialog.data, inputPayrollFrequency)
          break
        case DataType.PaymentScheduleAction.PAY_DOWN.value:
          this.store.commit('setMultiPayDownExtraPrincipal', data.maxPayDownAmount)
          this.multiDialog.data.transactionMode = input.transactionMode
          this.multiDialog.data.extraPrincipal = input.extraPrincipal
          break
      }
    },
    multiOperationFailureCallBack (err, input, changeType) {
      window._VMA.$emit('SHOW_SNACKBAR', { text: err.message, color: 'error' })
      this.multiDialog.disableSaveBtn = true
      this.multiDialog.data = input
      switch (changeType) {
        case DataType.PaymentScheduleAction.PAY_OFF_IN_N.value:
          this.store.commit('setMultiPayOffInNDebitCount', 2)
          break
        case DataType.PaymentScheduleAction.PAY_DOWN.value:
          this.store.commit('setMultiPayDownExtraPrincipal', 20)
          break
        case DataType.PaymentScheduleAction.PAY_OFF.value:
        default:
          break
      }
    }
  }
}
</script>
